<template>
  <div class="wait-list">
    <button
      :class="[classes, linkStyle ? 'link link--pseudo' : 'btn wait-list__btn', {'is-product-page': productPage, 'is-small-card': smallCard}]"
      type="button"
      :disabled="btnDisable"
      :aria-label="title"
      @click.stop="changeWaitListFlag"
    >
      <svg
        v-if="!linkStyle"
        class="wait-list__btn-img"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0006 18.3333C9.08017 18.3333 8.33398 17.5871 8.33398 16.6666H11.6673C11.6673 17.5871 10.9211 18.3333 10.0006 18.3333ZM16.6673 15.8333H3.33398V14.1666L5.00065 13.3333V8.74996C5.00065 5.86496 6.18482 3.99413 8.33398 3.48329V1.66663H11.6673V3.48329C13.8165 3.99329 15.0006 5.86329 15.0006 8.74996V13.3333L16.6673 14.1666V15.8333ZM10.0006 4.79163C8.98371 4.72596 8.00297 5.18102 7.39648 5.99996C6.87777 6.82042 6.62326 7.78028 6.66732 8.74996V14.1666H13.334V8.74996C13.378 7.78028 13.1235 6.82044 12.6048 5.99996C11.9983 5.18102 11.0176 4.72596 10.0006 4.79163Z" fill="#333333"/>
      </svg>
      <svg
        v-if="!linkStyle && isInWaitList"
        class="wait-list__btn-img-added"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="7.2"
                cy="7.2"
                r="6.8"
                fill="#FF2F00"
                stroke="white"
                stroke-width="0.8"/>
        <path d="M4.00195 7.26338L6.40208 9.66351L10.402 5.6001"
              stroke="white"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"/>
      </svg>

      <div class="wait-list__btn-title">
        {{ title }}
      </div>
    </button>
    <span v-if="isInWaitList && !isSmallCard && !linkStyle"
          class="wait-list__response">{{ $t('added_to_wait_list') }}</span>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'WaitListBtn',
  props: {
    productId: {
      type: Number,
      default: null
    },
    inWaitListStatus: {
      type: Boolean,
      default: false
    },
    classes: String,
    isSmallCard: Boolean,
    isMapModal: Boolean,
    linkStyle: Boolean,
    productPage: {
      type: Boolean,
      default: false
    },
    smallCard: {
      type: Boolean,
      default: false
    },
    storeId: {
      type: Number
    }
  },
  data: function () {
    return {
      token: '',
      btnDisable: false
    }
  },
  methods: {
    ...mapActions('waitlist', ['CHANGE_WAIT_LIST_STATUS']),
    changeWaitListFlag () {
      if (this.user && this.user.auth) {
        const infoModalWaitListBtn = document.getElementById(`wait-list-btn-${this.storeId}`)
        let postData

        if (this.storeId) {
          postData = {
            product_id: this.productId,
            remove: +this.isInWaitList,
            store_id: this.storeId
          }
        } else {
          postData = {
            product_id: this.productId,
            remove: +this.isInWaitList
          }
        }

        this.btnDisable = true

        this.CHANGE_WAIT_LIST_STATUS({ postData: postData })
          .then(response => {
            if (infoModalWaitListBtn) {
              infoModalWaitListBtn.innerText = this.isInWaitList ? this.$t('already_in_wait_list') : this.$t('add_to_wait_list')
            }

            this.btnDisable = false
            if (!this.isMapModal) this.notifySuccess(response.message)
          })
          .catch(error => {
            if (!this.isMapModal) this.notifyError(error)
          })
      } else {
        window.addEventListener('waitListTrigger', () => {
          if (!this.isInWaitList) this.changeWaitListFlag()
        })

        this.$modal.show('auth-modal', {
          title: this.$t('wait_list_auth_message'),
          isAjaxAuth: true,
          referrer: 'wait-list'
        })
      }
    },
    notifySuccess (message) {
      this.$notify({
        group: 'success',
        title: '',
        text: message,
        type: 'success'
      })
    },
    notifyError (message) {
      this.$notify({
        group: 'error',
        title: this.$t('error'),
        text: message,
        type: 'error'
      })
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapGetters('waitlist', ['productsIdsInWaitlist']),
    ...mapState('waitlist', ['waitListStatusInShops']),
    user () {
      return this.$store.state.user
    },
    title () {
      if (this.isMapModal) return this.isInWaitList ? this.$t('already_in_wait_list_store') : this.$t('add_to_wait_list_store')

      return this.isInWaitList ? this.$t('already_in_wait_list') : this.$t('add_to_wait_list')
    },
    isInWaitList () {
      if (this.storeId) return this.waitListStatusInShops[this.storeId]

      return this.productsIdsInWaitlist.includes(this.productId)
    }
  }
}
</script>

<style lang="sass" scoped>

/*.wait-list*/

.link
  background-color: transparent
  font-size: 14px
  font-weight: 400 //Rubik 300

.wait-list__btn
  display: flex
  font-size: 14px
  min-width: 200px
  justify-content: center
  align-items: center
  padding: 0 15px
  background-color: #f0f0f0
  color: $text-color
  border-color: transparent
  height: 46px
  position: relative

  &:hover,
  &:focus
    background-color: transparent
    border-color: #e1e1e1

.wait-list__btn--small
  height: auto
  padding: 6px 22px 7px
  font-size: 12px
  min-width: auto

  .wait-list__btn-img
    display: none

.wait-list--map-modal
  width: 48%

.wait-list--map-modal .wait-list__btn
  width: 100%
  display: block
  padding: 10px 0
  height: auto
  line-height: 18px

.wait-list--card .wait-list__btn
  height: 33px
  min-width: 170px
  padding: 0

  +mmax(550)
    height: 45px

  +mmax(359)
    height: 37px

.wait-list__btn-img
  line-height: 0
  margin-right: 10px
  flex-shrink: 0
  width: 24px
  height: 24px

.wait-list__btn-img-added
  width: 17px
  height: 17px
  position: absolute
  top: 5px
  right: 6px
  display: none

.wait-list__response
  display: flex
  align-items: center
  margin-top: 20px
  font-size: 14px
  font-weight: 400 //Rubik 300

  &:before
    content: ''
    display: block
    width: 20px
    height: 20px
    margin-right: 15px
    background-image: url(/img/svgo/product-page/wait-list.svg)
    background-repeat: no-repeat

.is-product-page
  width: 100%
  height: 50px
  padding: 0 31px

  +mmin($tablet)
    height: 40px

  +mmin(1360)
    width: auto

.is-product-page.is-small-card
  width: 100%
</style>
